exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h5 {\n  text-transform: uppercase;\n  text-align: center;\n}\n\np {\n  text-align: center;\n  letter-spacing: 2px;\n}\n\nimg {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  height:400px;\n  width:auto;\n}\n\n#products {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  height:450px;\n  width:auto;\n  padding-bottom: 20px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/nurture/src/app/homepage/homepage.component.css
// module id = ../../../../../src/app/homepage/homepage.component.css
// module chunks = main